import { PaymentType } from 'common/constants';

export const pathToDefaultPaymentTypeMap: Record<string, PaymentType> = {
  '/schedule': PaymentType.AccountsPayable,
  '/ap-payments': PaymentType.AccountsPayable,
  '/odc': PaymentType.OnDemand,
  '/on-demand-payments': PaymentType.OnDemand
};

export const WINDOW_POPUP_TARGET_SELF = '_self';
